import { Button } from '@ds';
import { useFormContext } from 'react-hook-form';

type FormActionsProps = {
  actions: {
    className?: string;
    size: 'sm' | 'md' | 'lg';
    discard?: {
      label: string;
      variant?: 'light' | 'outline';
      handler: () => void;
    };
    submit: {
      isSubmitting?: boolean;
      label: string;
      onSubmit?: (data: unknown) => void;
      validateData?: (data: unknown) => { isValid: boolean; errors?: Record<string, { message: string }> };
      forceEnabled?: boolean;
    };
  };
};

export const FormActions = ({ actions }: FormActionsProps) => {
  const {
    formState: { isValid, isSubmitting },
    getValues,
    setError,
  } = useFormContext();

  const handleSubmitClick = () => {
    const data = getValues();
    if (actions.submit.validateData) {
      const result = actions.submit.validateData(data);
      if (!result.isValid) {
        if (result.errors) {
          Object.entries(result.errors).forEach(([key, error]) => {
            setError(key, { type: 'manual', message: error.message });
          });
        }
        return;
      }
    }
    if (actions.submit.onSubmit) {
      actions.submit.onSubmit(data);
    }
  };

  const isSubmitDisabled = actions.submit.forceEnabled
    ? false
    : !isValid || actions.submit.isSubmitting || isSubmitting;

  return (
    <>
      {actions.discard && (
        <Button
          className={actions.className}
          size={actions.size}
          variant={actions.discard.variant ?? 'outline'}
          onClick={actions.discard.handler}
        >
          {actions.discard.label}
        </Button>
      )}
      <Button
        className={actions.className}
        size={actions.size}
        {...(actions.submit.onSubmit ? { onClick: handleSubmitClick } : { type: 'submit' })}
        isLoading={actions.submit.isSubmitting ?? isSubmitting}
        isDisabled={isSubmitDisabled}
      >
        {actions.submit.label}
      </Button>
    </>
  );
};
